import { Action, TemplateDeploymentState } from "types/generated";
import { AccessResult, EntityWithAllowedActions, NO_ACCESS_MESSAGE } from "utils/access";

import { isDeploymentUpdateDisabled, getUpdateDisabledTooltip } from "./helpers";

type DeploymentWithState = EntityWithAllowedActions & { state: TemplateDeploymentState };

export const canRollbackDeployment = (deployment: DeploymentWithState): AccessResult => {
  if (!deployment.allowedActions.includes(Action.RollbackBlueprintDeployment)) {
    return { result: false, message: NO_ACCESS_MESSAGE };
  }

  if (isDeploymentUpdateDisabled(deployment.state)) {
    return { result: false, message: getUpdateDisabledTooltip(deployment.state) };
  }

  return { result: true };
};
